import { Link } from "@tanstack/react-router";
import { Compass } from "lucide-react";

export function NotFoundPage() {
  return (
    <main className="entry-screen" id="main-content">
      <span className="brand-mark brand-mark--large">
        <Compass aria-hidden="true" />
      </span>
      <div className="empty-state">
        <p className="eyebrow">Pagina non trovata</p>
        <h1>Questa rotta non porta a un lead.</h1>
        <p>Controlla l'indirizzo oppure torna allo spazio di lavoro.</p>
        <Link to="/" className="button button--primary button--medium">
          Torna a Polaris Leads
        </Link>
      </div>
    </main>
  );
}
